// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.capture-odometer-reading-view {
  display: flex;
  flex-direction: column;
}
.capture-odometer-reading-view .capture-odometer-reading-view__icon-group {
  position: relative;
}
.capture-odometer-reading-view .capture-odometer-reading-view__icon-group .icon-group__background {
  color: #ebf9fe;
  position: relative;
}
.capture-odometer-reading-view .capture-odometer-reading-view__icon-group .icon-group__odometer {
  color: var(--main-1);
  font-size: 1.1em;
}
.capture-odometer-reading-view .capture-odometer-reading-view__text {
  color: var(--sub-6);
}
.capture-odometer-reading-view .capture-odometer-reading-view__input-label {
  color: var(--sub-8);
  font-weight: 600;
}
.capture-odometer-reading-view .capture-odometer-reading-view__input-container {
  border: 1px solid var(--sub-4);
}
.capture-odometer-reading-view .capture-odometer-reading-view__input-container .input-container__input {
  border: none;
  width: 100%;
  outline: none;
  color: var(--sub-6);
  font-weight: 600;
}
.capture-odometer-reading-view .capture-odometer-reading-view__input-container .input-container__input::placeholder {
  color: var(--sub-5);
  font-weight: normal;
}
.capture-odometer-reading-view .capture-odometer-reading-view__input-container .input-container__input::-webkit-input-placeholder {
  color: var(--sub-5);
  font-weight: normal;
}
.capture-odometer-reading-view .capture-odometer-reading-view__buttons-container {
  display: flex;
  justify-content: space-between;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
